import { useQuery } from 'react-query'
import axios from 'axios'

const URLS = {
  BIDATA: {
    MAKERS: `${process.env.NEXT_PUBLIC_API_ROOT}/api/vehicle/makes`,
    MODELS: `${process.env.NEXT_PUBLIC_API_ROOT}/api/vehicle/models`,
    VERSIONS: `${process.env.NEXT_PUBLIC_API_ROOT}/api/vehicle/versions`,
  },
  NOBIDATA: {
    MAKERS: '/api/makers',
    MODELS: `${process.env.NEXT_PUBLIC_API_ROOT}/api/vehicle/models`,
    VERSIONS: `${process.env.NEXT_PUBLIC_API_ROOT}/api/vehicle/versions`,
  },
}

const usePriceRating = (resource, type = 'BIDATA', params, enabled = true) => useQuery(['resource', { type, ...params }], async () => {
  const url = URLS[type][resource]
  const resp = await axios.get(url, {
    params,
  })
  const data = await resp.data
  return data
}, {
  enabled,
  refetchOnWindowFocus: false,
  refetchOnmount: false,
  refetchOnReconnect: false,
  retry: false,
  staleTime: 1000 * 60 * 24,
})
export default usePriceRating
